import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import AppointmentsApi from '../generated/api/Appointments';

export default (service: Servicelayer) => ({
  ...AppointmentsApi(service),

  // Add custom calls here

});
